import { render, staticRenderFns } from "./FeedWidget.vue?vue&type=template&id=2bda36d1&scoped=true"
import script from "./FeedWidget.vue?vue&type=script&lang=js"
export * from "./FeedWidget.vue?vue&type=script&lang=js"
import style0 from "./FeedWidget.vue?vue&type=style&index=0&id=2bda36d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda36d1",
  null
  
)

export default component.exports